<template>
    <div class="payment-success__picture">
        <img
            v-if="success === 'has-limit'"
            src="@speechki-frontend/shared/assets/img/success-illustr1.png"
            alt="Thank You!"
        />
        <img
            v-if="success === 'no-limit'"
            src="@speechki-frontend/shared/assets/img/success-illustr2.png"
            alt="Thank You!"
        />
    </div>
</template>

<script>
export default {
    name: 'SuccessIllustration',
    props: {
        success: {
            type: String,
            default: '',
        },
    },
};
</script>
